<template>
  <div   class="list">
    
    <div v-if="showCards">
        <CreditCard v-for="card in cardList" v-bind:key="card.id" 
        :cardInfo="card"
       @card_updated="deleteCardHandler()"
    />
    </div>
    <div v-else >No Cards on file </div> 

  </div>
</template>

<script setup>
import SVGIcon from '@/components/SVGIcon.vue';
import {onMounted, defineEmits, ref, watch, computed} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import CreditCard from '@/components/subscription/CreditCard.vue';

const emit = defineEmits(['card_updated']);
const props = defineProps({ cardList: Array});

const showCards = computed(() => {

  return true;
});

async function  deleteCardHandler() {
  emit('card_updated','');
}
</script>

<style lang="scss" scoped>

.credit-card {
  width: 300px;
  height: 20px;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 2px solid rgb(220, 217, 217);

  &._recommended {
    background-color: tint-color($color-success, 85%) !important;
    border: 2px solid var(--color-success);
  }
}

</style>
